import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { JoinPipe, SrPunctuationPipe } from '@woolworthsnz/styleguide';
import { SizeResponse } from '@woolworthsnz/trader-api';
import { NgIf } from '@angular/common';
import { Params, Router, RouterLink } from '@angular/router';

@Component({
	selector: 'product-price-meta-v2',
	template: `
		<div class="priceMeta cupPriceAdjustment" id="product-{{ uniqueId }}-unitPrice">
			<div class="cupPriceContainer">
				<span *ngIf="cupPrice" class="cupPrice" [attr.aria-label]="mainUnitPriceAriaLabel(cupPrice)"
					>{{ cupPrice }} <br
				/></span>
			</div>
			<ng-container *ngIf="tagLink && isCPUUIAdjustimentOn">
				<a
					[attr.aria-labelledby]="ariaLabelledBy"
					[routerLink]="tagLink?.path"
					[queryParams]="tagLink?.queryParams"
					[target]="tagLink.linkTarget"
				>
					<span *ngIf="tagLink.text">{{ tagLink.text }}</span>
				</a>
				<ng-container *ngIf="!!multiCupPrice && shouldShowMultiBuyCupPrice"
					>&nbsp;<span class="multiCupPrice" [attr.aria-label]="mainUnitPriceAriaLabel(multiCupPrice)">{{
						multiCupPrice
					}}</span>
				</ng-container>
			</ng-container>
			<ng-container *ngIf="!!noMemberCupPrice && shouldShowNoMemberCupPrice">
				Non-member&nbsp;<span
					class="noMemberCupPrice"
					[attr.aria-label]="mainUnitPriceAriaLabel(noMemberCupPrice)"
					>{{ noMemberCupPrice }}</span
				>
			</ng-container>
		</div>
	`,
	styleUrls: ['./price-meta-v2.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [NgIf, JoinPipe, RouterLink, SrPunctuationPipe],
})
export class PriceMetaV2Component {
	@Input() size: SizeResponse;
	@Input() cupPrice: string;
	@Input() noMemberCupPrice: string;
	@Input() shouldShowNoMemberCupPrice: boolean;
	@Input() multiCupPrice: string;
	@Input() shouldShowMultiBuyCupPrice: boolean;
	@Input() isKgItem: boolean;
	@Input() uniqueId: number;
	@Input() supportsEachAndKgPricing: boolean;
	@Input() tagLink: { path: string; queryParams: string | Params; text: string; linkTarget?: string };
	@Input() isCPUUIAdjustimentOn: boolean;

	constructor(protected router: Router) {}

	get ariaLabelledBy(): string {
		return `product-${this.uniqueId}-promoInfo`;
	}

	mainUnitPriceAriaLabel(cupPrice: string): string {
		return `Unit price ${cupPrice}`;
	}
}
